import React, { useState, useEffect, useLayoutEffect } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../Utilities";
// import ApplicationButton from "../../ApplicationButton";

import "../../Interview.css";
import "../../RadioInterview.css";
import "primereact/resources/themes/lara-light-cyan/theme.css"; // Theme
import "primeicons/primeicons.css"; // Icons
import "../../AutoCompleteChoice.css";

// const handleItemChoice = (e) => {
//   document.getElementById("submit-button").value = e.value.value;
// };

// const getDefault = (field) => {
//   for (let i = 0; i < field.choices.length; i++) {
//     if (field.choices[i].default) {
//       return field.choices[i].value;
//     }
//     return "";
//   }
// };
//

const AutoCompleteWrapper = (props) => {
  const targetName = `${props.interview.fields[0].variable_name || props.interview.fields[0].choices.variable_name}`;
  let fieldName = targetName;
  const lang = getCookie("DA-language");
  // eslint-disable-next-line
  const { t, i18n } = useTranslation();
  const translate = i18n.getFixedT(lang);
  const [scriptElement, setScriptElement] = useState(null);

  const [selectedItem, setSelectedItem] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  let placeholder_txt = translate("placeholder-txt");

  // Populate dropdown/ choices
  const fieldIndex = props.index;
  fieldName = props.interview.fields[fieldIndex].variable_name;
  // console.log("props = ", props);
  // console.log("props.interview.fields = ", props.interview.fields);

  let items = props.choices;
  // props.interview.fields[fieldIndex].choices.forEach((item) => {
  //   if (item.value === "select-title") {
  //     placeholder_txt = item.label;
  //   } else if (item.value === "dependent-on") {
  //     // dependent_on_field = item.label;
  //   } else {
  //     items.push({ label: item.label, value: item.value });
  //   }
  // });
  // console.log("items = ", items);

  // const handleDependentFields = (e) => {
  //   console.log("handleDependentFields (coming from AutoCompleteWrapper)");
  //   console.log("e = ", e);
  //   console.log("e.value = ", e.value);
  //   console.log("e.target = ", e.target);
  // };

  const search = (event) => {
    const query = event.query.toLowerCase();
    if (typeof items !== "undefined" && items.length > 0) {
      const filtered = items.filter((item) =>
        item.label.toLowerCase().includes(query),
      );
      setFilteredItems(filtered);
    }
  };

  useEffect(() => {
    if (typeof props.interview.script !== "undefined") {
      const newElement = document.createElement("script");
      setScriptElement(newElement);
      const inlineCode = document.createTextNode(props.interview.script);
      newElement.appendChild(inlineCode);
      document.body.appendChild(newElement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.interview.script]);

  useLayoutEffect(() => {
    if (scriptElement !== null) {
      document.body.removeChild(scriptElement);
      setScriptElement(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.interview.script]);

  return (
    <>
      <div className="label-wrapper" style={{  position: 'relative' }}>
      <AutoComplete
        id={fieldName}
        value={selectedItem}
        suggestions={filteredItems}
        completeMethod={search}
        field="label"
        onChange={(e) => {
          setSelectedItem(e.value);
          /* application-specific logic */
          try {
            if (
              e.value.label === "Aged Parent (subclass 804)" ||
              e.value.label === "Employer Nomination Scheme (subclass 186)"
            ) {
              document.querySelectorAll(".fitb-label")[1].outerHTML =
                '<div class="fitb-label">an</div>';
            } else if (e.value.label === "Some other type of") {
              document.querySelectorAll(".fitb-label")[1].outerHTML =
                '<div class="fitb-label">&nbsp;</div>';
            } else {
              document.querySelectorAll(".fitb-label")[1].outerHTML =
                '<div class="fitb-label">a</div>';
            }
          } catch (e) {}

          props.onChange(e);
        }}
        placeholder={placeholder_txt}
        className="w-full lg:w-auto"
        dropdown
        forceSelection
      />
      {selectedItem && (
        <i
          className="pi pi-times clear-button"
          onClick={() => setSelectedItem(null)}
        />
      )}
      </div>
    </>
  );
};

export default AutoCompleteWrapper;
